var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe",style:({height: _vm.height + 'px'})},[_c('iframe',{ref:"iframeDom",attrs:{"src":("http://ccc.cdboost.cn/" + _vm.url),"width":"100%","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }